'use client'

import type { CookiebotTriggerProps } from '@maestro/cookiebot-cookie-consent/components/cookiebot-trigger/cookiebot-trigger.types'

import { JSX } from 'react'

import { useCookiebotTrigger } from '@maestro/cookiebot-cookie-consent/components/cookiebot-trigger/batons/use-cookiebot-trigger'
import { Link } from '@pearlconvert/ui/components/link'

export default function CookiebotTrigger(
  props: CookiebotTriggerProps
): JSX.Element {
  const { customLabel } = props
  const { handleOnClick, label } = useCookiebotTrigger()

  return (
    <Link href="#" onClick={handleOnClick} role="button">
      {customLabel || label}
    </Link>
  )
}
